import React from 'react';

export const AboutStory = () => (
  <section className="reference-section about-story" id="our-story" data-testid="about-story">
    <div className="site-container about-story-layout">
      <div className="reference-heading">
        <span className="eyebrow">Our story</span>
        <h2 data-testid="about-story-title">YOUR NEIGHBORHOOD<br /><em>AUTO SHOP.</em></h2>
      </div>
      <div className="about-story-copy" data-testid="about-story-copy">
        <p data-testid="about-story-intro">Performance Lube 915 started with a dream Paul and Rene refused to give up on. Through hard work and flat-out refusing to quit, that dream didn't just come true — it became a reality.</p>
        <p>Performance Lube 915 is locally owned and 915 to the bone — two shops in El Paso, one crew, and a simple standard: fix it right, price it straight, and show you the proof.</p>
        <p>From express oil changes to brake rotors, fuel injector cleaning, tires, and diagnostics, everything happens under our own roof. No hand-offs, no mystery line items, no upsell theater — just the work your car actually needs, done same-day whenever we can.</p>
        <p>That's why El Paso keeps coming back — and why 130+ Google reviewers rate us 4.9 stars.</p>
      </div>
    </div>
  </section>
);